import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../../ui/utils/Responsive';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import {
	StyledLabel,
	StyledPrice,
	StyledSummaryLabelPrice,
} from './BookingSummarySavings';
import { useLoyaltyAccountStore } from '../../../../../account/domain/stores/useLoyaltyAccountStore';
import { BadgeTag } from '../../../../../account/ui/shared/BadgeTag';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useFormatNumberWithSeparator } from '../../../../../shared/utils/useFormatNumberWithSeparator';

interface IBookingSummaryPromotionsProps {
	promoCode: string;
	discount: IPrice | undefined;
}
export const BookingSummaryPromotions = ({
	promoCode,
	discount,
}: IBookingSummaryPromotionsProps) => {
	const { t } = useTranslation();
	const { promoCode: loyaltyPromoCode } = useLoyaltyAccountStore();
	const newBookingsStore = useNewBookingStore();
	const { parkingProductsQuoteLoyaltyPromotions: loyaltyPromotions } =
		newBookingsStore;
	const { formatWithSeparator } = useFormatNumberWithSeparator();

	return (
		<div>
			<StyledSummaryLabelPrice>
				<StyledLabel>{t('web_booking_summary_promotions')}</StyledLabel>
				<StyledLoyaltyPromotionWrap>
					{loyaltyPromotions && loyaltyPromotions.pointsCost && (
						<BadgeTag
							text={`-${t('loyalty_offer_points_template', {
								points: formatWithSeparator(loyaltyPromotions.pointsCost),
							})}`}
						/>
					)}
					{discount && Boolean(+discount) && (
						<StyledPrice>
							{discount ? `-${getFormattedPrice(discount)}` : ''}
						</StyledPrice>
					)}
				</StyledLoyaltyPromotionWrap>
			</StyledSummaryLabelPrice>
			{!loyaltyPromoCode && (
				<div>
					<StyledPromotions>{promoCode.toUpperCase()}</StyledPromotions>
				</div>
			)}
		</div>
	);
};
export default BookingSummaryPromotions;

const StyledLoyaltyPromotionWrap = styled.div`
	display: flex;
	gap: 16px;
`;

const StyledPromotions = styled.div`
	height: 32px;
	font-size: 12px;
	display: inline-block;
	border-radius: 4px;
	padding: 8px 10px;
	background-color: #f7f7f7;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		background-color: #ffffff;
	}
`;
